import { NameFormatter } from './name-formatter';

export class VzgNameFormatter implements NameFormatter {
    format(name: string): string {
        return name.slice(-4);
    }
}